import { useQuery } from '@tanstack/react-query';
import useApi from 'hooks/useApi';
import { useTranslation } from 'react-i18next';
import languagesFactory from 'utils/factories/languages';

export const useLanguages = () => {
  const api = useApi();

  const {
    i18n: { language: locale },
  } = useTranslation();

  return useQuery({
    queryKey: languagesFactory.list({ locale }),
    queryFn: () => api.languages.apiLanguagesGetCollection({ locale }),
    select: (res) => res?.data['hydra:member'],
  });
};

export const useAllLanguages = () => {
  const api = useApi();

  const {
    i18n: { language: locale },
  } = useTranslation();

  return useQuery({
    queryKey: languagesFactory.allLang({ locale }),
    queryFn: () => api.languages.apiLanguagesallGetCollection({ locale }),
    select: (res) => res?.data['hydra:member'],
  });
};
